export enum SnippetDestinyEnum {
  DELETE = 'delete',
  MOVE = 'move',
}

export const snippetDestinyRadioButtonText = {
  [SnippetDestinyEnum.DELETE]: 'Delete all included snippets permanently',
  [SnippetDestinyEnum.MOVE]: 'Move to another category',
};
